import React, { useState, useEffect } from 'react';
import CloseIcon from '../../../../assets/icons/close.svg';
import { AuthenticatedPOSTRequest, gotoLocation } from '../../../../utils';

const BranchesModal = (props) => {
    const { open, id, list, onClose, onError } = props;
    const [branchId, setBranchId] = useState(null);
    const [loading, setLoading] = useState(false);

    const onRegisterApplicant = async () => {
        setLoading(true);
        try {
            const values = { branch_id: branchId };
            const { success, message } = await AuthenticatedPOSTRequest(
                `applicants/${id}/accept_applicant_as_a_student`,
                values,
            );
            if (!success) {
                setLoading(false);
                onClose();
                onError(`Error=${message}`);
                return;
            } else {
                setLoading(false);
                onClose();
                return gotoLocation('dashboard/applicants');
            }
        } catch (error) {
            onError('براہ کرم دوبارہ کوشش کریں۔');
        }
    };

    useEffect(() => {
        if (list && list.length > 0) {
            setBranchId(list[0].id || 0);
        }
    }, [list]);

    return open ? (
        <div
            className='flex column justifyCenter alignCenter'
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000,
                background: 'rgba(0,0,0,0.7)',
            }}
        >
            <div
                style={{
                    background: '#ffffff',
                    height: 320,
                    maxHeight: 320,
                    width: 576,
                    borderRadius: 8,
                }}
            >
                <div className='h-100 w-100' style={{ overflow: 'auto' }}>
                    <div
                        className='flex justifyBetween alignCenter w-100'
                        style={{
                            borderBottom: '1px solid #E0E0E0',
                            padding: '20px 16px 8px',
                        }}
                    >
                        <h2 className='flex alignCenter w-100' style={{ color: '#009688' }}>
                            درخواست دہندہ کو رجسڑ کرنے کے لیے پہلے برانچ منتخب کریں
                        </h2>

                        <img
                            src={CloseIcon}
                            alt='close_icon'
                            height={32}
                            width={32}
                            onClick={onClose}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>

                    <div className='flex column urdu' style={{ padding: 20 }}>
                        <label htmlFor='branch' style={{ fontSize: 20, marginBottom: 8 }}>
                            برانچ منتخب کریں
                        </label>
                        <select
                            name='branch'
                            onChange={(e) => {
                                if (e.target.value.length > 0) {
                                    setBranchId(e.target.value);
                                } else {
                                    setBranchId(null);
                                }
                            }}
                            style={{ height: 44, fontSize: 20, padding: 4 }}
                        >
                            {list &&
                                list.length > 0 &&
                                list.map((item, index) => (
                                    <option value={item.id} key={index + 1}>
                                        {item.name['urdu']}
                                    </option>
                                ))}
                        </select>
                    </div>

                    <div className='flex justifyEnd alignCenter'>
                        <div
                            className='flex justifyEnd alignCenter register_button'
                            style={{ margin: '0 20px 0', paddingTop: 12 }}
                            onClick={() => onRegisterApplicant()}
                        >
                            {loading ? (
                                <div className='custom_loader' />
                            ) : (
                                <h3>منتخب کریں اور پھر رجسٹر کریں</h3>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

export default BranchesModal;
